import React, {useEffect, useState} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

import CloseNudge from "./images/cancel.svg";

import { getItemFromSession, setItemInSession } from "../../../../../utils/helpers/session-storage";
import TestDriveYourDreamCarPopup from "./test-drive-your-dream-car-popup/component";
import { trackDesktopCustomEventsAU } from "../../../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../../../tracking/au.desktop-events";
const TestDriveNudge = ({showTestDriveVariant, location}) => {

    const [showTestDriveStripNudge, setShowTestDriveStripNudge] = useState(false);
    const [showTestNudgePopup, setShowTestNudgePopup] = useState(false);
    useEffect(() => {
        const closedTestDriveNudge = getItemFromSession("CLOSED_TEST_DRIVE_STRIP_NUDGE");
        if (closedTestDriveNudge) {
            setShowTestDriveStripNudge(false);
        } else {
            setShowTestDriveStripNudge(true);
        }
    }, []);

    const closeNudgeHandler = () => {
        setItemInSession("CLOSED_TEST_DRIVE_STRIP_NUDGE", true);
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_TD_STRIP_INTERACTION, {
            eventAction: "interaction type",
            eventLabel: "close"
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_TD_STRIP_INTERACTION, {
            eventAction: "location",
            eventLabel: location
        });
        setShowTestDriveStripNudge(false);
    };
    const showTestNudgePopupHandler = () => {
        if (showTestNudgePopup) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_TD_STRIP_POPUP_CLOSED, {
                eventAction: "location",
                eventLabel: location
            });
        } else {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_TD_STRIP_INTERACTION, {
                eventAction: "interaction type",
                eventLabel: "click"
            });
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_TD_STRIP_INTERACTION, {
                eventAction: "location",
                eventLabel: location
            });
        }
        setShowTestNudgePopup(!showTestNudgePopup);
    };
    return (
        <React.Fragment>
            {showTestDriveStripNudge && showTestDriveVariant ? <div styleName={"styles.nudgeWrapper"}>
                <div className="container" styleName={"styles.nudgeContainer"}>
                    <p styleName={"styles.nudgeText"} onClick={showTestNudgePopupHandler}>
                        Test drive your dream car for free! Learn how
                    </p>
                    <img src={CloseNudge} onClick={closeNudgeHandler} />
                </div>
            </div> : null}
            {showTestNudgePopup && <TestDriveYourDreamCarPopup onClick={showTestNudgePopupHandler}/>}
        </React.Fragment>
    );
};

TestDriveNudge.propTypes = {
    showTestDriveVariant: PropTypes.bool,
    location: PropTypes.string
};
export default TestDriveNudge;
